import { Banner, Button } from '@shopify/polaris';
import { useNavigate } from 'react-router-dom';

/**
 * T048: NotificationBanner — persistent "Your scan is complete" banner.
 * Shows on any page when a scan has completed until the merchant dismisses it.
 */

interface NotificationBannerProps {
  jobId: string;
  onDismiss: () => void;
}

export function NotificationBanner({ jobId, onDismiss }: Readonly<NotificationBannerProps>) {
  const navigate = useNavigate();

  return (
    <Banner
      title="Your scan is complete"
      tone="success"
      onDismiss={onDismiss}
    >
      <p>
        AI readiness scores have been calculated for your products.{' '}
        <Button
          variant="plain"
          onClick={() => {
            navigate(`/scan-complete/${jobId}`);
            onDismiss();
          }}
        >
          View results →
        </Button>
      </p>
    </Banner>
  );
}
